export enum WatcherType {
  IntersectionWatcher = 'intersection_watcher',
  KeyPressWatcher = 'key_press_watcher',
  KeyReleaseWatcher = 'key_release_watcher',
  MouseClickWatcher = 'mouse_click_watcher',
  MousePositionWatcher = 'mouse_position_watcher'
}
